export const RIGHT_PAYMENT = 101401;
export const RIGHT_PAYMENT_SEARCH = 101401;
export const RIGHT_PAYMENT_ADD = 101402;
export const RIGHT_PAYMENT_EDIT = 101403;
export const RIGHT_PAYMENT_DELETE = 101404;

export const RIGHT_BILL_PAYMENT_SEARCH = 156201;
export const RIGHT_BILL_PAYMENT_CREATE = 156202;
export const RIGHT_BILL_PAYMENT_UPDATE = 156203;
export const RIGHT_BILL_PAYMENT_DELETE = 156204;
export const RIGHT_BILL_PAYMENT_REFUND = 156206;

export const DEFAULT_DEBOUNCE_TIME = 200;
export const EMPTY_STRING = "";
export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100];
export const DEFAULT_PAGE_SIZE = 10;
export const ENUM_PREFIX_LENGTH = 2;

export const PAYMENT_MAIN_STATUS = {
  NOT_RECONCILIATED: "0",
  RECONCILIATED: "1",
  REFUNDED: "2",
  CANCELLED: "3",
};

export const CONTAINS_LOOKUP = "Icontains";
export const STARTS_WITH_LOOKUP = "Istartswith";

export const MODULE_NAME = "payment";

export const PAYMENT_STATUS = [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5];
export const PAYMENTS_TAB_VALUE = "paymentsTab";
export const FAMILY_TYPE_POLYGAMY_CODE = "P";
